export enum SearchGeographyKind {
  US = "us",
  STATES = "states",
  COUNTIES = "counties",
  NOT_APPLICABLE = "not_applicable",
  // Only a Research Sufficiency gap names this: required proof searches the
  // formation state of a Legal Entity Company Scope does not hold, so no
  // Research Task could ever search it (WB-1605).
  FORMATION_JURISDICTION_UNKNOWN = "formation_jurisdiction_unknown",
}
